export function getToken(): string {
  const { token } = JSON.parse(localStorage.getItem('spartacus⚿⚿auth') || '{}');
  const { access_token } = token;

  return access_token;
}
